import { useQuestions } from '@hooks/useQuestions';
import { QuestionItem } from './QuestionItem';
import type { Locale } from '@types';
import styles from './QuestionsList.module.css';

interface QuestionsListProps {
    locale: Locale;
}

/**
 * Container component for client questionnaire
 * Displays all questions and manages responses
 */
export function QuestionsList({ locale }: QuestionsListProps) {
    const {
        questions,
        isLoading,
        error,
        updateResponse,
        getResponse
    } = useQuestions();

    if (isLoading) {
        return (
            <div className={styles.questions_loading}>
                <p>{locale === 'en' ? 'Loading questions...' :
                     locale === 'ru' ? 'Загрузка вопросов...' :
                     'Сұрақтар жүктелуде...'}</p>
            </div>
        );
    }

    if (error) {
        return (
            <div className={styles.questions_error}>
                <p>{locale === 'en' ? `Error loading questions: ${error}` :
                     locale === 'ru' ? `Ошибка загрузки вопросов: ${error}` :
                     `Сұрақтарды жүктеу қатесі: ${error}`}</p>
            </div>
        );
    }

    if (questions.length === 0) {
        return null;
    }

    const sectionTitle = locale === 'en' ? 'Project Questionnaire' :
                        locale === 'ru' ? 'Анкета проекта' :
                        'Жоба сауалнамасы';

    const sectionDescription = locale === 'en' ?
        'Please provide details about your project requirements' :
        locale === 'ru' ?
        'Пожалуйста, укажите детали требований вашего проекта' :
        'Жобаңыздың талаптары туралы мәліметтерді көрсетіңіз';

    return (
        <section className={styles.questions_section}>
            <div className={styles.questions_header}>
                <h2 className={styles.section_title}>{sectionTitle}</h2>
                <p className={styles.section_description}>{sectionDescription}</p>
            </div>

            <div className={styles.questions_list}>
                {questions.map(question => (
                    <QuestionItem
                        key={question.id}
                        question={question}
                        value={getResponse(question.id)}
                        onChange={(value) => updateResponse(question.id, value)}
                        locale={locale}
                    />
                ))}
            </div>
        </section>
    );
}